import {observer} from "mobx-react";
import ConsignmentReports from "./consignmentReports.jsx";

export default observer(function AdminBalance(props) {
  return (
    <div className="p-2 text-black">
      <ConsignmentReports {...props} />
    </div>
  );
});
